import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnChildOrganization, SnOrganization } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class OrganizationsAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getList(params: ISnListQueryParameters): Observable<ISnListResponse<SnOrganization>> {
    return this._httpClient.get('/api/organizations/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((organization) => new SnOrganization(organization)),
      })),
    );
  }
  public getOrderedList(
    params: ISnListQueryParameters,
  ): Observable<ISnListResponse<SnOrganization>> {
    return this._httpClient.get('/api/organizations/ordered/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((organization) => new SnOrganization(organization)),
      })),
    );
  }

  public getRegistryChildOrganizationsList(
    params: ISnListQueryParameters,
  ): Observable<ISnListResponse<SnChildOrganization>> {
    return this._httpClient.get('/api/registry/child-organizations/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((organization) => new SnChildOrganization(organization)),
      })),
    );
  }

  public getRegistryOrganization(id: string): Observable<SnChildOrganization> {
    return this._httpClient
      .get(`/api/registry/child-organizations/${id}/`)
      .pipe(map((response: any) => new SnChildOrganization(response)));
  }
}
